import { inputBaseClasses } from '@mui/material/InputBase';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiOutlinedInput = {
  defaultProps: { notched: false },
  styleOverrides: {
    root: ({ theme }) => ({
      '--Input-focused': 0,
      '--Input-bg': 'var(--mui-palette-background-paper)',
      '--Input-focusedHighlight': `rgba(${theme.vars.palette.primary.mainChannel} / 0.18)`,
      '--Input-focusedThickness': '3px',
      '--Input-borderWidth': '1px',
      '--Input-borderColor': 'var(--mui-palette-OutlinedInput-border)',
      '--Input-boxShadow': 'var(--mui-shadows-1)',
      backgroundColor: 'var(--Input-bg)',
      border: 'var(--Input-borderWidth) solid var(--Input-borderColor)',
      boxShadow: 'var(--Input-boxShadow)',
      transition: theme.transitions.create(
        ['background-color', 'border-color', 'box-shadow'],
        {
          duration: theme.transitions.duration.shorter,
        }
      ),
      '&::before': {
        borderRadius: 'inherit',
        bottom: 0,
        boxShadow:
          '0 0 0 calc(var(--Input-focused) * var(--Input-focusedThickness)) var(--Input-focusedHighlight)',
        content: '" "',
        left: 0,
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        top: 0,
      },
      '&:hover': { '--Input-borderColor': 'var(--mui-palette-text-secondary)' },
      '&:focus-within': { '&::before': { '--Input-focused': 1 } },
      'label + &': { marginTop: '6px' },
      [`&.${outlinedInputClasses.error}`]: {
        '--Input-borderColor': 'var(--mui-palette-error-main)',
        '--Input-focusedHighlight': `rgba(${theme.vars.palette.error.mainChannel} / 0.18)`,
      },
      [`&.${outlinedInputClasses.disabled}`]: {
        '--Input-bg': 'var(--mui-palette-background-level1)',
        '--Input-boxShadow': 'none',
      },
    }),
    input: {
      height: 'auto',
      padding: 0,
      [`label[data-shrink=false]+.${inputBaseClasses.formControl} &`]: {
        '&::placeholder': { opacity: '1 !important' },
      },
    },
    notchedOutline: { display: 'none' },
  },
} satisfies Components<Theme>['MuiOutlinedInput'];
